import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-716c033f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hline" }, null, -1 /* HOISTED */))
const _hoisted_2 = { class: "profile-wrapper" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "mini-cogs" }
const _hoisted_5 = { class: "profile-cog" }
const _hoisted_6 = { href: "#" }
const _hoisted_7 = {
  key: 1,
  class: "cogs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_unicon = _resolveComponent("el-unicon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`profile-outer ${!$options.isToggle?'open':'close'} ${$data.isToggleProfile && !$options.isToggle ? 'profile-open':'profile-close'}`)
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (_ctx.user.profile_pic)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              ref: "userProfilePicRef",
              src: _ctx.user.profile_pic,
              alt: `eComPIM - ${$options.username}`,
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($options.handleProfileOpen && $options.handleProfileOpen(...args)), ["prevent"])),
              onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.handleImgError && $options.handleImgError(...args)))
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_el_popover, {
          placement: "right-start",
          title: "",
          width: "200",
          trigger: "hover",
          "popper-class": "profile-wrapper-pop-hover",
          "virtual-ref": _ctx.$refs.userProfilePicRef,
          "virtual-triggering": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, { to: "/user/profile" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_unicon, {
                    name: "user",
                    fill: "#B3B8ED",
                    height: "16px",
                    width: "16px"
                  }),
                  _createTextVNode(" Profile ")
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($options.logOut && $options.logOut(...args)), ["prevent"]))
              }, [
                _createVNode(_component_el_unicon, {
                  name: "signout",
                  fill: "#B3B8ED",
                  height: "16px",
                  width: "16px"
                }),
                _createTextVNode(" Logout ")
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["virtual-ref"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!$options.isToggle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cogs-open",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($options.handleProfileOpen && $options.handleProfileOpen(...args)), ["prevent"]))
            }, [
              _createElementVNode("span", null, _toDisplayString($options.username), 1 /* TEXT */),
              _createElementVNode("a", _hoisted_6, [
                _createVNode(_component_el_unicon, {
                  name: `angle-${$data.isToggleProfile ? 'up': 'right'}`,
                  fill: "#B3B8ED",
                  height: "25px",
                  width: "25px"
                }, null, 8 /* PROPS */, ["name"])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.isToggleProfile && !$options.isToggle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_router_link, { to: "/user/profile" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_unicon, {
                    name: "user",
                    fill: "#B3B8ED",
                    height: "16px",
                    width: "16px"
                  }),
                  _createTextVNode(" Profile ")
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($options.logOut && $options.logOut(...args)), ["prevent"]))
              }, [
                _createVNode(_component_el_unicon, {
                  name: "signout",
                  fill: "#B3B8ED",
                  height: "16px",
                  width: "16px"
                }),
                _createTextVNode(" Logout ")
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 2 /* CLASS */))
}